<div class="dialog-container">
    <button mat-icon-button class="close-button" id="close-button" mat-dialog-close type="button">
        <fa-icon icon="times" />
    </button>
    <div mat-dialog-title class="app-header">Action Activity by Play</div>
    <mat-form-field>
        <mat-select [ngModel]="selectedFilter$ | async" (selectionChange)="dateRangeChange($event.value)">
            @for (date of dateFilters; track $index) {
                <mat-option [value]="date[1].toISO()">{{ date[0] }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    <div mat-dialog-content class="body-container">
        <div class="action-activity-chart">
            <r1-compass-app-stacked-drilldown-chart
                [chartData]="chartData"
                (viewDetails)="loadPlayReportingDetails($event)" />
        </div>
        <div class="action-activity-error-details">
            @if (selectedPlayId()) {
                <div class="action-activity-error-details">
                    <r1-compass-lib-divider />
                    <span
                        >Play Id: <a href="{{ selectedPlayUrl() }}" target="_blank">{{ selectedPlayId() }}</a></span
                    >
                    @if (selectedPlay()) {
                        <div>{{ 'Play Type: ' + selectedPlay()?.type }}</div>
                    }
                    <r1-compass-lib-report-table
                        [reportData]="reportData()"
                        [appSpecificColumns]="appSpecificColumns"
                        [appSpecificDetails]="appSpecificDetails"
                        [appSpecificErrorLinks]="[]"
                        [errorTableData]="[]"
                        [interactionErrorTableData]="interactionErrorTableData()"
                        (expandRow)="getInteractionErrorTableData($event)"
                        (downloadSupportDetails)="downloadSupportData($event)" />
                </div>
            }
        </div>
    </div>
</div>
